import { render, staticRenderFns } from "./UtenteDialog.vue?vue&type=template&id=c4615acc"
import script from "./UtenteDialog.vue?vue&type=script&lang=js"
export * from "./UtenteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports